import { Component, OnInit } from '@angular/core';
import { FlowServiceService } from '../../Services/flow-service.service';

@Component({
  selector: 'app-thirdpartyliabraries',
  templateUrl: './thirdpartyliabraries.component.html',
  styleUrls: ['./thirdpartyliabraries.component.scss']
})
export class ThirdpartyliabrariesComponent implements OnInit {
  sections = [
    { id: 'introduction', title: '1. Introduction' },
    { id: 'angular-core', title: '2. Angular Core Libraries' },
    { id: 'angular-ui', title: '3. Angular UI Libraries' },
    { id: 'ui-frameworks', title: '4. UI Frameworks & Components' },
    { id: 'payment-services', title: '5. Payment & Services' },
    { id: 'utilities', title: '6. Utilities & Tools' }
  ];

  constructor(private flowServiceService: FlowServiceService) { 
    window.scrollTo(0,0);
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  ngOnInit(): void {
    window.scrollTo(0,0);
    this.flowServiceService.setScrollTop();
  }
}
